import React from 'react';

function MatomoTagManagerLoader({ src }) {

  React.useEffect(() => {
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({
      'mtm.startTime': new Date().getTime(),
      event: 'mtm.Start'
    });

    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];
    g.async = true;
    g.src = src;
    s.parentNode.insertBefore(g, s);

    if (!window.__MATOMO_REQ_METHOD_SET__) {
      window.__MATOMO_REQ_METHOD_SET__ = true;
      window._paq = window._paq || [];
      window._paq.push(['setRequestMethod', 'GET']);
    }

  }, []);

  return null;
}

export default MatomoTagManagerLoader;